import { FieldValues } from 'react-hook-form';
import { useFormSectionContext } from '@/components/Form/FormSectionContext';
import { Text } from 'react-native-paper';
import { useWindowDimensions, View } from 'react-native';
import Button from '@/components/Button';
import { Border, Breakpoints, Color, Padding } from '@/GlobalStyles';

type FormSectionFooterProps = {
  onPress: () => void;
  previousLabel?: string;
  firstPrevOnPress?: () => void;
  beforeChange?: () => void;
  firstPrevLabel?: string;
  nextLabel?: string;
  saveLabel?: string;
  saveLoading?: boolean;
  saveDisabled?: boolean;
};

const FormSectionFooter = <T extends FieldValues>(props: FormSectionFooterProps) => {
  const {
    onPress,
    previousLabel = 'Précédent',
    nextLabel = 'Suivant',
    saveLabel = 'Valider',
    saveLoading,
    saveDisabled,
    firstPrevLabel,
    beforeChange,
    firstPrevOnPress,
  } = props;
  const {
    goNext,
    goPrev,
    currentSection,
    sectionsCount,
    pageCount,
    paginations,
    nextButtonLabel,
    prevButtonLabel,
    nextButtonProps,
    prevButtonProps,
    showPagination,
  } = useFormSectionContext<T>();
  const { width } = useWindowDimensions();

  if (sectionsCount === undefined) {
    return null;
  }
  return (
    <View
      style={{
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        marginRight: -40,
        paddingRight: 40,
      }}
    >
      {goPrev ? (
        <Button
          contentStyle={{
            minWidth: width < Breakpoints.tablet ? 0 : 150,
          }}
          mode={'outlined'}
          outerStyle={{ borderWidth: 0 }}
          {...prevButtonProps}
          onPress={goPrev}
          labelStyle={{ marginHorizontal: Padding.p_mid }}
        >
          {prevButtonLabel || previousLabel}
        </Button>
      ) : firstPrevLabel ? (
        <Button
          contentStyle={{
            minWidth: width < Breakpoints.tablet ? 0 : 150,
          }}
          mode={'outlined'}
          outerStyle={{ borderWidth: 0 }}
          {...prevButtonProps}
          onPress={firstPrevOnPress}
          labelStyle={{ marginHorizontal: Padding.p_mid }}
        >
          {firstPrevLabel}
        </Button>
      ) : null}
      {showPagination && (pageCount ?? 0) > 1 ? (
        <View
          style={{
            minWidth: 75,
            marginHorizontal: Padding.p_xs,
            backgroundColor: Color.blanc,
            paddingHorizontal: Padding.p_xs,
            height: 48,
            shadowColor: 'rgba(0, 0, 0, 0.13)',
            shadowOffset: {
              width: -10,
              height: 10,
            },
            borderRadius: Border.br_3xs,
            shadowRadius: 40,
            elevation: 40,
            shadowOpacity: 1,
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 100,
          }}
        >
          <Text style={{ color: Color.MainNoir, opacity: 0.5 }}>
            {paginations && paginations[`${currentSection}`]} | {pageCount}
          </Text>
        </View>
      ) : (
        <View
          style={{
            marginLeft: Padding.p_xs,
          }}
        ></View>
      )}
      {goNext ? (
        <Button
          contentStyle={{ minWidth: width < Breakpoints.tablet ? 0 : 150 }}
          {...nextButtonProps}
          onPress={() => {
            beforeChange && beforeChange();
            goNext && goNext();
          }}
          labelStyle={{ marginHorizontal: Padding.p_mid }}
        >
          {nextButtonLabel || nextLabel}
        </Button>
      ) : (
        <Button
          loading={saveLoading}
          disabled={saveDisabled}
          contentStyle={{ minWidth: width < Breakpoints.tablet ? 0 : 150 }}
          {...nextButtonProps}
          labelStyle={{ marginHorizontal: Padding.p_mid }}
          onPress={onPress}
        >
          {nextButtonLabel || saveLabel}
        </Button>
      )}
    </View>
  );
};

export default FormSectionFooter;
